import _slicedToArray from "/Users/vitalyrtishchev/code/mantine-master/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { Mark, mergeAttributes, getMarkAttributes } from '@tiptap/core';
var TextStyle = Mark.create({
  name: 'textStyle',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'span',
      getAttrs: function getAttrs(element) {
        var hasStyles = element.hasAttribute('style');

        if (!hasStyles) {
          return false;
        }

        return {};
      }
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      removeEmptyTextStyle: function removeEmptyTextStyle() {
        return function (_ref2) {
          var state = _ref2.state,
              commands = _ref2.commands;
          var attributes = getMarkAttributes(state, _this.type);
          var hasStyles = Object.entries(attributes).some(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                value = _ref4[1];

            return !!value;
          });

          if (hasStyles) {
            return true;
          }

          return commands.unsetMark(_this.name);
        };
      }
    };
  }
});
export { TextStyle, TextStyle as default };